export const CardRegisterErrorMessage = {
  inputDataError:
    'クレジットカード登録時にエラーが発生しました。\n' +
    '入力内容が正しいことをご確認ください。',
  apiDataError:
    'クレジットカード登録時にエラーが発生しました。\n' +
    '下記メッセージを確認のうえ、アプリからお問い合わせください。\n' +
    '\u3000マイページ ＞ その他 ＞ お問い合わせ',
};

export const CardRegisterSettlementErrorMessage = {
  parameterError:
    'カード情報に誤りがある可能性があります。\n' +
    'カード情報の登録内容に誤りがある場合は、再度登録をおこなっていただくか、別のカードをご利用ください。',
  cardCompanyRejectionError:
    'カード会社でエラーが発生しました。\n' +
    '・カード情報に誤りがないかをご確認ください。\n' +
    '・カードの利用可能枠（限度額）をご確認ください。\n' +
    '・お心当たりが無い場合は、ご利用のカード会社にお問い合わせいただくか、別のカードをご利用ください。',
  cardCompanyConnectionError:
    'カード会社との通信エラーが発生しました。\n' +
    '時間をおいてから、再度{0}をおこなってください。\n' +
    '状況が改善されない場合は、別のカードをご利用ください。',
  authenticationError:
    '本人認証のエラーが発生しました。\n' +
    '・本人認証画面で入力した情報に誤りがないかをご確認ください。',
  unsupportedCardError:
    'このカードはタヨリスではご利用になれません。\n' +
    '別のカードをご利用ください。',
  expiredError:
    '本人認証の有効時間が過ぎてしまったため、お支払いが承認されませんでした。再度お支払いの操作をおこなってください。',
  cardSettlementOtherErrors:
    'お支払いが承認されませんでした。再度お支払いの操作をおこなってください。\n' +
    '状況が改善されない場合は、別のカードをご利用ください。',
  cardRegisterOtherErrors:
    'カード情報が登録されておりません。再度カード情報の登録をおこなってください。\n' +
    '状況が改善されない場合は、別のカードをご利用ください。',
  settlementAction: 'お支払いの操作',
  cardRegisterAction: 'カード情報の登録',
};
